import { render } from "./standart-help-panel.vue?vue&type=template&id=4c03c614&ts=true"
import script from "./standart-help-panel.vue?vue&type=script&lang=ts"
export * from "./standart-help-panel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__